import { TAccountFeatures } from '../account.model';

export function getDefaultAccountFeatures(): TAccountFeatures {
  return {
    pdfSignatures: false,
    timeline: false,
    aalSitePlan: false,
    aalExport: false,
    pdfYcoLayout: false,
    fleetManagement: false,
  };
}
